import { FC, useEffect } from "react";
import { Link } from "react-router-dom";
import { MemberCarpet } from "../../../typings/member";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { filter } from "lodash";
import { getMemberPremiumStatus } from "../../../services/memberService";

export type BounakirItemProps = {
  member: MemberCarpet;
  selected: number;
  canShowProfilePicture: boolean;
  memberSendStickerToReciver: boolean;
  deleteFootPrint: Function;
};

const BounakirItem: FC<BounakirItemProps> = ({
  member,
  selected,
  canShowProfilePicture,
  memberSendStickerToReciver,
  deleteFootPrint,
}) => {
  //selected is people that watched me and are not premium
  const styles = {
    filter:
      selected === 4 && !canShowProfilePicture ? "blur(17px)" : "blur(0px)",
  };

  const link = usePrepareLink({
    state: {
      navigateFromProfile: true,
    },
    query: {
      [GET_PARAMS.memberCode]: member.memberCode,
    },
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.profile,
    },
    keepOldQuery: true,
  });

  const premiumMessagelink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
    },
    keepOldQuery: true,
  });
  const matchType = () => {
    switch (selected) {
      case 1:
        return "/assets/images/ic_bou_bordo.svg"; // sent by me
      case 2:
        return "/assets/images/ic_bou_violet.svg"; // sent to me
      case 3:
        return "/assets/images/ic_shosh_red.svg"; // double match
      case 4:
        return "/assets/images/ic_bou_purple.svg"; // visited me
      default:
        return "";
    }
  };

  return (
    <>
      <li className="gallery_list_item">
        <div style={styles} className="item_pict_block">
          {member?.profileImageUrl && (
            <img
              src={member?.profileImageUrl}
              loading="lazy"
              alt=""
              className="item_pict"
            />
          )}
        </div>
        <Link
          to={
            selected === 4 && !canShowProfilePicture ? premiumMessagelink : link
          }
          className="gallery_link w-inline-block"
        >
          {(member.isNewRequestForReceiver ||
            member.isNewDoubleMatchForSender ||
            member.isUnwatchedFootPrint) && (
            <div className="new_status">חדש</div>
          )}
          <div className="item_status_group">
            <div className="status_icon">
              <img src={matchType()} loading="lazy" alt="" />
            </div>
            {memberSendStickerToReciver && (
              <div className="status_icon gift">
                <img src="assets/images/ic_gift_sm.svg" loading="lazy" alt="" />
              </div>
            )}
          </div>
          {selected !== 4 && <h2 className="item_title">{member.userName}</h2>}
          {selected === 4 && canShowProfilePicture && (
            <h2 className="item_title">{member.userName}</h2>
          )}
        </Link>
      </li>
      {/* <button onClick={() => deleteFootPrint()}>מחיקה</button> */}
    </>
  );
};

export default BounakirItem;
